import {
    ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS,
    ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED,
    RESET_ADDORUPDATESUBMODULEMASTERFORADMIN,
    LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN,
    NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADDORUPDATESUBMODULEMASTERFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
